/**
 * Constants.js - Barèmes et taux sociaux 2025
 * Toutes les valeurs sont basées sur la législation en vigueur au 01/01/2025
 */

// ==================== PLAFONDS ANNUELS SÉCURITÉ SOCIALE ====================
export const PASS = 46368; // Plafond Annuel de la Sécurité Sociale 2025
export const PASS_MENSUEL = PASS / 12; // 3864 €

// ==================== SMIC ====================
export const SMIC_HORAIRE = 12.31; // SMIC horaire brut (≈ mensuel / 151,67h)
export const SMIC_MENSUEL = 1867.02; // SMIC mensuel brut (base 151,67h)
export const SMIC_ANNUEL = SMIC_MENSUEL * 12; // 22404,24 €

// ==================== TAUX MICRO-ENTREPRISE ====================
export const TAUX_MICRO = {
  PRESTATIONS_SERVICE_BIC: {
    cotisations_sociales: 21.2, // %
    impot_liberatoire: 1.7,    // % (option)
    total_avec_impot: 22.9,    // %
    abattement_fiscal: 50,     // %
  },
  PRESTATIONS_SERVICE_BNC: {
    cotisations_sociales: 21.1, // %
    impot_liberatoire: 2.2,    // % (option)
    total_avec_impot: 23.3,    // %
    abattement_fiscal: 34,     // %
  },
  VENTE_MARCHANDISES: {
    cotisations_sociales: 12.3, // %
    impot_liberatoire: 1.0,    // % (option)
    total_avec_impot: 13.3,    // %
    abattement_fiscal: 71,     // %
  },
  LOCATION_MEUBLEE: {
    cotisations_sociales: 6.0,  // %
    impot_liberatoire: 0,      // %
    total_avec_impot: 6.0,     // %
    abattement_fiscal: 50,     // %
  },
  SEUILS: {
    BIC_VENTE: 188700,         // €
    BIC_PRESTATIONS: 77700,    // €
    BNC: 77700,                // €
    LOCATION_MEUBLEE: 77700,   // €
  },
};

// ==================== ENTREPRISE INDIVIDUELLE (EI) - RÉGIME RÉEL ====================
export const TAUX_EI = {
  // Cotisations sociales (TNS - Travailleur Non Salarié)
  MALADIE_MATERNITE: 0, // Gratuit si revenu < 0.6 * PASS
  MALADIE_MATERNITE_COMPLETE: 6.50, // % si revenu > 0.6 * PASS
  INDEMNITES_JOURNALIERES: 0.85, // %
  
  RETRAITE_BASE: {
    tranche1: 17.75,  // % jusqu'à 1 PASS
    tranche2: 0.60,   // % de 1 à 5 PASS
  },
  
  RETRAITE_COMPLEMENTAIRE: {
    tranche1: 7.00,   // % jusqu'à 1 PASS
    tranche2: 8.00,   // % de 1 à 4 PASS
  },
  
  INVALIDITE_DECES: 1.30,      // %
  ALLOCATIONS_FAMILIALES: 3.10, // %
  CSG_CRDS: 9.70,              // %
  FORMATION_PRO: 0.25,         // %
  
  // Taux global approximatif
  TAUX_GLOBAL_APPROX: 45,      // % (pour estimation rapide)
};

// ==================== SASU - ASSIMILÉ SALARIÉ ====================
export const TAUX_SASU = {
  // Part salariale (prélevée sur le brut)
  PART_SALARIALE: {
    MALADIE: 0,                    // %
    VIEILLESSE_PLAFONNEE: 6.90,    // % (tranche 1)
    VIEILLESSE_DEPLAFONNEE: 0.40,  // %
    RETRAITE_COMPLEMENTAIRE_T1: 3.15, // % (tranche 1)
    RETRAITE_COMPLEMENTAIRE_T2: 8.64, // % (tranche 2)
    CEG_T1: 0.86,                  // %
    CEG_T2: 1.08,                  // %
    APEC: 0.024,                   // % (cadres uniquement)
    ASSURANCE_CHOMAGE: 0,          // % (pas de chômage en SASU)
    CSG_CRDS: 9.70,                // %
    TOTAL_APPROX: 22,              // % approximatif
  },
  
  // Part patronale (en plus du brut)
  PART_PATRONALE: {
    MALADIE_MATERNITE: 13.00,      // %
    VIEILLESSE_PLAFONNEE: 8.55,    // %
    VIEILLESSE_DEPLAFONNEE: 1.90,  // %
    ALLOCATIONS_FAMILIALES: 3.45,  // %
    ACCIDENT_TRAVAIL: 0.71,        // % (taux moyen)
    FNAL: 0.50,                    // %
    CONTRIBUTION_SOLIDARITE: 0.30, // %
    RETRAITE_COMPLEMENTAIRE_T1: 4.72, // %
    RETRAITE_COMPLEMENTAIRE_T2: 12.95, // %
    CEG_T1: 1.29,                  // %
    CEG_T2: 1.62,                  // %
    APEC: 0.036,                   // % (cadres)
    ASSURANCE_CHOMAGE: 0,          // % (pas en SASU)
    FORMATION_PRO: 1.00,           // %
    TOTAL_APPROX: 45,              // % approximatif
  },
  
  // Charges totales
  CHARGES_TOTALES_APPROX: 67,      // % (salariales + patronales)
  
  // Impôt sur les sociétés
  IS_TAUX_REDUIT: 15,              // % jusqu'à 42500€
  IS_TAUX_NORMAL: 25,              // % au-delà
  IS_SEUIL: 42500,                 // €
};

// ==================== CAE - PARAMÈTRES PAR DÉFAUT ====================
export const PARAMS_CAE_DEFAULT = {
  // Contribution CAE (gestion administrative)
  CONTRIBUTION_POURCENTAGE: 14,    // %
  
  // RCP CAE (Responsabilité Civile Professionnelle)
  // Bâtiment : forfait mensuel + 3% du CA HT
  FORFAIT_RCP_CAE_BATIMENT: 20,        // € mensuel
  tx_decennale_batiment: 0.03,               // 3% du CA HT
  // Hors bâtiment : forfait mensuel fixe
  FORFAIT_RCP_CAE_HORS_BATIMENT: 15,   // € mensuel
  
  // Provision pour intéressement
  PROVISION_INTERESSEMENT: 3.15,   // %
  
  // Charges forfaitaires mensuelles (mutuelle + médecine du travail)
  CHARGES_FORFAITAIRES_MUTUELLES: 84,                      // € mensuel
  CHARGES_FORFAITAIRES_ANNUEL_MEDECINE_TRAVAIL: 95,        // € annuel (÷ 12 pour mensuel)
  
  // Cotisation fédération URSCOP
  COTISATION_FEDE_URSCOP: 12.594,  // € mensuel
  
  // Titres restaurant (optionnel)
  TITRES_RESTAURANT: 0,            // € par mois (désactivé par défaut)
  
  // Taux de charges sociales sur salaire (salarié classique)
  CHARGES_SOCIALES_SALARIE: 22,    // % (part salariale)
  CHARGES_SOCIALES_PATRONALES: 45, // % (part patronale)
  CHARGES_SOCIALES_TOTALES: 67,    // % (total)
};

// ==================== DÉFAUTS CHARGES HORS CAE ====================
// Ces valeurs servent de secours si config.json ne définit pas defaults_charges_hors_cae
export const DEFAULTS_CHARGES_HORS_CAE = {
  logiciel_formation: 200,  // € mensuel – logiciel de formation
  compte_bancaire: 10,      // € mensuel – frais bancaires pro
  logiciel_compta: 20,      // € mensuel – logiciel de comptabilité
  assurance_rcp: 15,        // € mensuel – assurance RCP (hors Bâtiment)
  assurance_decennale: 250, // € mensuel – décennale (Bâtiment uniquement)
  comptable: 250,           // € mensuel – honoraires comptable
  cet_cvae_cfe: 27,         // € mensuel – CET (CVAE + CFE)
  mutuelle_prevoyance: 75,  // € mensuel – mutuelle + prévoyance
};

// ==================== PLAFONDS DE CHARGES ====================
// Valeurs de secours si config.json ne définit pas max_charges
export const MAX_CHARGES = {
  indemnites_km: 1000,      // € mensuel max indemnités kilométriques
  repas_affaires: 20 * 21.4, // € mensuel max repas d'affaires (20 × 21,4 €)
};

// ==================== BARÈME IMPÔT SUR LE REVENU 2025 ====================
export const BAREME_IR_2025 = [
  { max: 11294, taux: 0 },         // Tranche 0%
  { max: 28797, taux: 11 },        // Tranche 11%
  { max: 82341, taux: 30 },        // Tranche 30%
  { max: 177106, taux: 41 },       // Tranche 41%
  { max: Infinity, taux: 45 },     // Tranche 45%
];

// ==================== AIDES ET EXONÉRATIONS ====================
export const AIDES = {
  ACRE: {
    duree_mois: 12,                // Durée de l'ACRE
    exoneration_cotisations: 50,   // % d'exonération (première année)
    plafond_revenu: 32994,         // € (seuil pour bénéficier de l'ACRE)
  },
  
  REDUCTION_FILLON: {
    coefficient_max: 0.3195,       // Coefficient maximal
    seuil_bas: 1.0,                // Multiple du SMIC
    seuil_haut: 1.6,               // Multiple du SMIC
  },
  
  EXONERATION_COTISATIONS_DEBUT: {
    seuil_ca_annuel: 10000,        // € CA annuel mini pour être exonéré
  },
};

// ==================== FRAIS PROFESSIONNELS ====================
export const FRAIS_PRO = {
  // Déduction forfaitaire (pour salariés)
  DEDUCTION_FORFAITAIRE: 10,       // %
  
  // Frais réels déductibles (exemples courants)
  FRAIS_REELS: {
    deplacement_km: 0.665,         // € par km (barème 2025, véhicule 5CV)
    repas: 15.50,                  // € par repas (si justifié)
    telephonie: 50,                // € par mois (usage professionnel)
    internet: 30,                  // € par mois
  },
};

// ==================== TVA ====================
export const TVA = {
  TAUX_NORMAL: 20,                 // %
  TAUX_INTERMEDIAIRE: 10,          // %
  TAUX_REDUIT: 5.5,                // %
  TAUX_PARTICULIER: 2.1,           // %
  
  // Franchise en base de TVA (micro-entreprise)
  FRANCHISE_BIC_VENTE: 91900,      // €
  FRANCHISE_BIC_PRESTATIONS: 36800, // €
  FRANCHISE_BNC: 36800,            // €
};

// ==================== MESSAGES ET LABELS ====================
export const LABELS = {
  STATUTS: {
    CAE: 'CAE (Salarié en coopérative)',
    MICRO: 'Micro-entreprise',
    EI: 'Entreprise Individuelle (EI)',
    SASU: 'SASU (Assimilé salarié)',
  },
  
  PROTECTION_SOCIALE: {
    MALADIE: 'Assurance maladie',
    RETRAITE: 'Retraite (base + complémentaire)',
    CHOMAGE: 'Assurance chômage',
    ACCIDENT_TRAVAIL: 'Accidents du travail',
    FORMATION: 'Formation professionnelle',
    PREVOYANCE: 'Prévoyance (décès, invalidité)',
  },
  
  FISCALITE: {
    IR: 'Impôt sur le revenu',
    IS: 'Impôt sur les sociétés',
    CFE: 'Cotisation Foncière des Entreprises',
    CVAE: 'Cotisation sur la Valeur Ajoutée',
  },
};

// ==================== COULEURS POUR GRAPHIQUES ====================
export const CHART_COLORS = {
  CAE: '#00A651',           // Vert CAE
  MICRO: '#FF9800',         // Orange
  EI: '#2196F3',            // Bleu
  SASU: '#9C27B0',          // Violet
  
  POSITIF: '#4CAF50',       // Vert
  NEGATIF: '#F44336',       // Rouge
  NEUTRE: '#9E9E9E',        // Gris
};

// ==================== MESSAGES D'ERREUR ====================
export const ERROR_MESSAGES = {
  CA_REQUIRED: 'Le chiffre d\'affaires est obligatoire',
  CA_INVALID: 'Le chiffre d\'affaires doit être un nombre positif',
  CHARGES_INVALID: 'Les charges doivent être un nombre positif',
  EMAIL_INVALID: 'L\'adresse email n\'est pas valide',
  CONFIG_LOAD_ERROR: 'Erreur lors du chargement de la configuration',
};

// ==================== HELPERS ====================
export const formatEuro = (montant) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(montant);
};

export const formatPourcentage = (valeur) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(valeur / 100);
};

export const arrondir = (nombre, decimales = 2) => {
  return Math.round(nombre * Math.pow(10, decimales)) / Math.pow(10, decimales);
};
